document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.ugc-video-gallery').forEach(function (gallery) {
    var track = gallery.querySelector('.ugc-video-gallery__track');
    var prev = gallery.querySelector('.ugc-video-gallery__nav--prev');
    var next = gallery.querySelector('.ugc-video-gallery__nav--next');

    if (!track) return;

    function scrollByCard(direction) {
      var card = track.querySelector('.ugc-video-card');
      var amount = card ? card.getBoundingClientRect().width + 16 : 260;
      track.scrollBy({ left: amount * direction, behavior: 'smooth' });
    }

    function updateNavState() {
      if (!prev || !next) return;
      var maxScroll = track.scrollWidth - track.clientWidth - 1;
      prev.hidden = track.scrollLeft <= 0;
      next.hidden = track.scrollLeft >= maxScroll;
    }

    if (prev) prev.addEventListener('click', function () { scrollByCard(-1); });
    if (next) next.addEventListener('click', function () { scrollByCard(1); });

    track.addEventListener('scroll', updateNavState, { passive: true });
    window.addEventListener('resize', updateNavState);
    updateNavState();

    var videos = gallery.querySelectorAll('video[autoplay]');
    if ('IntersectionObserver' in window && videos.length) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target;
            if (entry.isIntersecting) {
              video.play().catch(function () {});
            } else {
              video.pause();
            }
          });
        },
        { threshold: 0.4 }
      );
      videos.forEach(function (video) { observer.observe(video); });
    }
  });
});
